<template>
    <div class="vertical-flow" v-if="data != null">
        <div class="card-title-custom mb-2">
            <p class="is-size-4">
                {{ $t("motivo-despesa") }}:
                {{ data.despesaMotivo.descricao }}
                <em :class="data.despesaMotivo.icone.toLowerCase()"></em>
            </p>
        </div>
        <hr />

        <div class="columns is-flex-wrap">
            <div class="column is-4">
                {{ $t("valor") }}: <br />
                {{ getDecimal(data.valor, null, true) }}
            </div>
            <div class="column is-4">
                {{ $t("valor-km-detalhe") }}: <br />
                {{ getDecimal(data.despesaDespesaPda.valorkm, null, true) }}
            </div>
            <div class="column is-4">
                {{ $t("data") }}: <br />
                {{ data.datahorainc | moment("L") }}
            </div>
            <div class="column is-4">
                {{ $t("empresa") }}: <br />
                {{ data.empresa.nome }}
            </div>
            <div class="column is-4">
                {{ $t("colaborador") }}: <br />
                {{ data.usuario.nome }}
            </div>
            <div class="column is-4">
                {{ $t("distancia-detalhe") }}: <br />
                {{
                    (data.despesaDespesaPda.distanciapercorrida * 0.001)
                        | decimal(3)
                }}
            </div>
            <div class="column is-8">
                {{ $t("origem") }}: <br />
                {{ data.clienteCheckin.nome }}
            </div>
            <div class="column is-4">
                <!-- 
                @70209 - Implementado toltip caso venha zerada a coordenada da tabela check
                -->
                {{ $t("origem") }} {{ $t("gps") }}:
                <b-icon 
                    v-if="
                        data.checkin.latitudecheckin == 0 &&
                        data.checkin.longitudecheckin == 0
                    "
                    icon="information" 
                    size="is-small" 
                    v-tippy 
                    :title="$t('informacao-origem-gps')"
                />
                <br />
                Lat {{ formatGeo(data.latitudeCheckin) }} Lng
                {{ formatGeo(data.longitudeCheckin) }}
            </div>
            <div class="column is-8">
                {{ $t("destino") }}: <br />
                {{ data.clienteCheckout.nome }}
            </div>
            <div class="column is-4">
                <!-- 
                    @70209 - Implementado toltip caso venha zerada a coordenada da tabela check
                -->
                {{ $t("destino") }} {{ $t("gps") }}:
                <b-icon 
                    v-if="
                        data.checkout.latitudecheckin == 0 &&
                        data.checkout.longitudecheckin == 0
                    "
                    icon="information" 
                    size="is-small" 
                    v-tippy 
                    :title="$t('informacao-origem-gps')"
                />
                <br />
                Lat {{ formatGeo(data.latitudeCheckout) }} Lng
                {{ formatGeo(data.longitudeCheckout) }}
            </div>
        </div>
    </div>
</template>

<script>
import RelatorioKmAutomaticoService from "@/services/despesas/RelatorioKmAutomaticoService";

export default {
    data() {
        return {
            data: null,
            service: new RelatorioKmAutomaticoService(this.$http, this.$router),
            isLoading: false,
            permissao: {},
        };
    },
    props: {
        id: 0,
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "despesas",
            "relatorios",
            "des-relatorio-km-automatico"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "relatorios" },
            });
        } else {
            if (this.id != 0) {
                this.carregarDados(this.id);
            } else {
                this.$router.push({ name: "des-relatorio-km-automatico" });
            }
        }
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((res) => {
                    this.data = res.content;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        /**
         * @70209 - Formatar as coordenadas.
         */
        formatGeo(number) {
            return number.toLocaleString("en-US", {
                minimumFractionDigits: 6,
                maximumFractionDigits: 10,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.card-title-custom {
    text-align: center;
}
.b-table .table {
    border-collapse: collapse;
}
.hero-body-img {
    padding: 20px;
}
.cursor-pointer {
    cursor: pointer;
}
@media screen and (max-width: 768px) {
    .b-table .table {
        border-collapse: separate;
    }
    .colums-mobile {
        width: 100% !important;
    }
    .b-table
        .table-wrapper.has-mobile-cards
        tr:not(.detail):not(.is-empty):not(.table-footer)
        td {
        justify-content: left;
        text-align: left;
    }
    .b-table .table-wrapper.has-mobile-cards .table-footer {
        margin-top: 15px;
        padding-left: 5px;
    }
}
</style>
